import { useEffect, useState } from "react";

import { AddAppointmentForm } from "components/AddAppointment/AddAppointmentForm/AddAppointmentForm";
import { AddAppointmentNavbar } from "components/AddAppointment/AddAppointmentNavbar/AddAppointmentNavbar";
import { AddExceptionForm } from "components/AddAppointment/AddExceptionForm/AddExceptionForm";
import { AddRecurringExceptionForm } from "components/AddAppointment/AddRecurringExceptionForm/AddRecurringExceptionForm";
import { Dialog } from "components/ui/Dialog";
import { useExceptionTypes } from "features/appointments/hooks/useExceptionTypes";
import { useDoctors } from "features/practice/hooks/useDoctors";
import { usePracticeServices } from "features/practice/hooks/usePracticeServices";

export const AddAppointmentModal = ({
  initialData,
  initialDoctor,
  startDate,
  startTime,
  staffId,
  allTimes,
  closeModal,
  isOpen,
  refetchCalendar,
  defaultAppointmentType,
  slotDurationMinutes,
}) => {
  const { data: services } = usePracticeServices();
  const { data: staffMembers } = useDoctors();
  const { data: exceptionTypes } = useExceptionTypes();

  const [appointmentType, setAppointmentType] = useState(
    defaultAppointmentType || "appointment"
  );

  useEffect(() => {
    if (defaultAppointmentType) {
      setAppointmentType(defaultAppointmentType);
    }
  }, [defaultAppointmentType]);

  return (
    <Dialog
      open={isOpen}
      title={initialData ? "Edit" : "Book a slot time"}
      onClose={closeModal}
      width={1000}
    >
      {!defaultAppointmentType && (
        <AddAppointmentNavbar
          appointmentType={appointmentType}
          setAppointmentType={setAppointmentType}
        />
      )}
      {appointmentType === "appointment" && (
        <AddAppointmentForm
          key={`${startDate}-${startTime}-${initialData?.id}`}
          initialData={initialData}
          initialStaffMember={staffId}
          initialStartDate={startDate}
          initialStartTime={startTime}
          staffMembers={staffMembers}
          closeModal={closeModal}
          allTimes={allTimes}
          initialDoctor={initialDoctor}
          services={services}
          refetchCalendar={refetchCalendar}
          slotDurationMinutes={slotDurationMinutes}
        />
      )}
      {appointmentType === "recurring-exception" && (
        <AddRecurringExceptionForm
          key={`${startDate}-${startTime}-${initialData?.id}`}
          initialData={initialData}
          initialStaffMember={staffId}
          initialStartDate={startDate}
          initialStartTime={startTime}
          staffMembers={staffMembers}
          closeModal={closeModal}
          allTimes={allTimes}
          initialDoctor={initialDoctor}
          services={services}
          refetchCalendar={refetchCalendar}
          exceptionTypes={exceptionTypes}
        />
      )}
      {appointmentType === "standard-exception" && (
        <AddExceptionForm
          key={`${startDate}-${startTime}-${initialData?.id}`}
          initialData={initialData}
          initialStaffMember={staffId}
          initialStartDate={startDate}
          initialStartTime={startTime}
          staffMembers={staffMembers}
          closeModal={closeModal}
          allTimes={allTimes}
          initialDoctor={initialDoctor}
          services={services}
          refetchCalendar={refetchCalendar}
          exceptionTypes={exceptionTypes}
        />
      )}
    </Dialog>
  );
};
